import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Carousel.css';

const Carousel = () => {
  const images = [
    './LakshmanMandir.jpg',
    './hemkund.jpg',
    './hemkund3.jpg',
    './lake.jpg',
    './Valley.jpg',
    './Ghangaria.jpg',
    './Badrinath2.jpg',
    './Narsingh Mandir.jpg'
  ];

  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(1); // Start from 1 to skip the first clone
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [visible, setVisible] = useState(true);

  const totalSlides = images.length;
  const extendedImages = [images[totalSlides - 1], ...images, images[0]]; // Clone first and last image

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [currentIndex]);

  const nextSlide = () => {
    if (currentIndex >= totalSlides) {
      setIsTransitioning(false);
      setCurrentIndex(0);
      setTimeout(() => {
        setCurrentIndex(1);
        setIsTransitioning(true);
      }, 50);
    } else {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex <= 0) {
      setIsTransitioning(false);
      setCurrentIndex(totalSlides);
      setTimeout(() => {
        setCurrentIndex(totalSlides - 1);
        setIsTransitioning(true);
      }, 50);
    } else {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  return (
    <div className="carousel" id='carousel'>
       <div className="carousel-bg"></div>
      <div
        className="carousel-slider"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: isTransitioning ? "transform 1s ease-in-out" : "none",
        }}
      >
        {extendedImages.map((image, index) => (
          <div key={index} className="carousel-item">
            <img src={image} alt={`Slide ${index}`} />
          </div>
        ))}
      </div>

      <button className="prev-button" onClick={prevSlide}>&laquo;</button>
      <button className="next-button" onClick={nextSlide}>&raquo;</button>

      <div className="carousel-indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`indicator ${currentIndex - 1 === index ? "active" : ""}`}
            onClick={() => setCurrentIndex(index + 1)}
          ></span>
        ))}
      </div>
       {visible && <div className="important-note">
       <h5>🏞️ Kagbhusandi Tal Trek</h5>
       <p>
          Discover the pristine glacial lake nestled in the Himalayas, surrounded by myth and natural beauty.
        </p>
       <button onClick={()=>navigate('/treks/kagbhusandi')} className='submitbtn'>Wanna Check ?</button>
      <button onClick={() => setVisible(false)} className="note-close">×</button>
    </div>}
    </div>
  );
};

export default Carousel;
